import { CalculationSchema } from "src/features/calculator/schema"
import { UseFormSetValue } from "react-hook-form"
import { useEffect } from "react"

type Props = {
  calculatedValue: number
  currentValue: number
  fieldName: keyof CalculationSchema
  setValue: UseFormSetValue<CalculationSchema>
}

export function useFormValueUpdate({ calculatedValue, currentValue, setValue, fieldName }: Props) {
  useEffect(() => {
    if (calculatedValue !== currentValue) {
      setValue(fieldName, calculatedValue)
    }
  }, [calculatedValue, setValue])
}
